var string_utils    = { },
    dates_utils     = { },
    browser_utils   = { };


const isIpadOS = () => {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}

string_utils.tiny = (text, max = 50) => {
    if (typeof (text) !== 'string')
        return '';
    else
        return text.length > max ? (text.substring (0, max) + '...') : text;
}

browser_utils.isMobile = () => {
    var mobileCheck = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()));

    if (isIpadOS ())
        mobileCheck = true;
    
    return mobileCheck;
}
browser_utils.isIpadOS = () => isIpadOS ();

dates_utils.months = [
    { text: "January", value: 0 },
    { text: "February", value: 1 },
    { text: "March", value: 2 },
    { text: "April", value: 3 },
    { text: "May", value: 4 },
    { text: "June", value: 5 },
    { text: "July", value: 6 },
    { text: "august", value: 7 },
    { text: "September", value: 8 },
    { text: "October", value: 9 },
    { text: "November", value: 10 },
    { text: "December", value: 11 }
]
dates_utils.days = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31 ]


module.exports = {
    STRING: string_utils,
    DATES: dates_utils,
    BROWSER: browser_utils
}